import { useSelector } from 'react-redux'
import { LoadingStatus } from 'shared/types'
import { selectors as commonSelectors } from 'shared/store'

export const usePaymentMethods = () => {
  const { data: paymentMethods, loading: paymentMethodsLoading } = useSelector(
    commonSelectors.payments.getPaymentMethodsState
  )

  const isLoading = [LoadingStatus.Pending, LoadingStatus.Idle].includes(
    paymentMethodsLoading
  )

  return { paymentMethods, isLoading }
}
